export default function RadioButtons({ label, name, value, onChange, disabled = false }) {
    return (
        <div className='dropRegDiv'>
            <label className='dropRegLabel'>{label}</label>

            <div className='dropRegInputDiv radioDiv'>
                <label>
                    <input
                        type='radio'
                        name={name}
                        value='true'
                        checked={value === true}
                        onChange={() => onChange(true)}
                        disabled={disabled}
                    />
                    Yes
                </label>

                <label>
                    <input
                        type='radio'
                        name={name}
                        value='false'
                        checked={value === false}
                        onChange={() => onChange(false)}
                        disabled={disabled}
                    />
                    No
                </label>
            </div>
        </div>
    );
}
